export const PRICING_TABLE = [
  { min: 75, max: 199, engage: 499, engagePlus: 549 },
  { min: 200, max: 299, engage: 599, engagePlus: 699 },
  { min: 300, max: 399, engage: 699, engagePlus: 849 },
  { min: 400, max: 499, engage: 799, engagePlus: 999 },
  { min: 500, max: 599, engage: 999, engagePlus: 1249 },
  { min: 600, max: 699, engage: 1199, engagePlus: 1499 },
  { min: 700, max: 799, engage: 1399, engagePlus: 1749 }
]

export const SETUP_TABLE = {
  engage: { 75: 499, 200: 599, 300: 699, 400: 799, 500: 999, 600: 1199, 700: 1399 },
  engagePlus: { 75: 549, 200: 699, 300: 849, 400: 999, 500: 1249, 600: 1499, 700: 1749 }
}

export const PREMIUM_SUPPORT_MONTHLY = 99

export function getPricingRow(rooms) {
  return PRICING_TABLE.find(r => rooms >= r.min && rooms <= r.max) || null
}

export function getDefaultPrice(plan, rooms, billing) {
  const row = getPricingRow(rooms)
  if (!row) return 0
  const base = plan === 'engage' ? row.engage : plan === 'engagePlus' ? row.engagePlus : 0
  const multipliers = { monthly: 1, quarterly: 3, semiAnnual: 6, annual: 12 }
  const discounts = { monthly: 0, quarterly: 0.03, semiAnnual: 0.07, annual: 0.12 }
  const m = multipliers[billing] || 1
  const d = discounts[billing] || 0
  return Math.round(base * m * (1 - d))
}

export function getDefaultSetupFee(plan, rooms) {
  if (plan === 'custom') return 499
  const row = getPricingRow(rooms)
  if (!row) return 499
  return plan === 'engage' ? row.engage : row.engagePlus
}

/** API `plans` tokens (order used when serializing). Must match backend allowed values. */
export const API_PLAN_ORDER = ['DirectfulCore', 'Unlimited', 'Email', 'CartAbandonment']

/** Maps UI service ids to backend `plans` entries (in-property tier is `Unlimited`). */
export const SERVICE_ID_TO_API_PLAN = {
  core_sms: 'DirectfulCore',
  inproperty: 'Unlimited',
  email_drip: 'Email',
  cart_abandonment: 'CartAbandonment'
}

export const ALL_SERVICES = [
  {
    id: 'core_sms',
    label: 'Core SMS',
    internalName: 'SMS Marketing',
    description: 'Pre-arrival, post-stay, review solicitation campaigns',
    icon: '💬'
  },
  {
    id: 'inproperty',
    label: 'In-Property Messaging',
    internalName: 'SMS In-Property',
    description: 'Day-before, check-in, in-house messaging & chatbot',
    icon: '🏨'
  },
  {
    id: 'email_drip',
    label: 'Email — Drip Campaigns',
    internalName: 'Email: Drip',
    description: 'Automated email sequences for need periods, holidays, seasons',
    icon: '📧',
    isAddon: true
  },
  {
    id: 'cart_abandonment',
    label: 'Cart Abandonment',
    internalName: 'Email + SMS: Cart Abandonment',
    description: 'Site & cart abandonment recovery via Email and SMS',
    icon: '🛒',
    isAddon: true
  }
]

export const PLAN_LOCKED = {
  engage: ['core_sms'],
  engagePlus: ['core_sms', 'inproperty'],
  custom: ['core_sms']
}

export const PLANS = [
  {
    id: 'engage',
    label: 'Directful Engage',
    shortLabel: 'Engage',
    color: '#4079F5',
    description: 'Core SMS marketing suite'
  },
  {
    id: 'engagePlus',
    label: 'Directful Engage+',
    shortLabel: 'Engage+',
    color: '#7C3AED',
    description: 'Engage + In-Property messaging'
  },
  {
    id: 'custom',
    label: 'Custom',
    shortLabel: 'Custom',
    color: '#0F766E',
    description: 'Manually select any combination of services'
  }
]

export const BILLING_OPTIONS_MAIN = [
  { id: 'annual', label: 'Annual' },
  { id: 'semiAnnual', label: 'Semi-Annual' },
  { id: 'quarterly', label: 'Quarterly' }
]

export const BILLING_OPTION_MONTHLY = { id: 'monthly', label: 'Monthly' }

export const BILLING_OPTIONS = [...BILLING_OPTIONS_MAIN, BILLING_OPTION_MONTHLY]

export const PROPERTY = {
  name: 'Baymont by Wyndham Downtown',
  id: 'PROP-00142',
  address: '2500 33rd Street, Orlando, FL 32839',
  rooms: 124,
  csm: 'Sarah Mitchell',
  contractEnd: 'Jun 30, 2025',
  currentPlan: 'engage',
  currentBilling: '',
  currentServices: ['core_sms'],
  currentPackageFee: 499,
  currentSetupFee: 499,
  setupFeeWaived: false,
  premiumSupport: false
}

export function fmt(n) {
  return Number(n).toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0
  })
}

export function cls(...args) {
  return args.filter(Boolean).join(' ')
}
